<template>
  <div class="mesJustificatifsChargeDocument mt-2">
    <div class="charge-document">
      <div
        class="charge-document-component"
        style="cursor: pointer;"
        @click="downloadDocument(documentClub)"
      >
        <div class="charge-document-content">
          <img :src="require('@/assets/download.png')" /><br />
          {{ this.documentTitre }} <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    documentTitre: String,
    documentClub: undefined
  },
  methods: {
    downloadDocument(documentObj) {
      try {
        var fileURL = "data:application/pdf;base64," + documentObj.data;
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", documentObj.nom);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.erreurGlobale =
          "Une erreur est survenue lors du téléchargement du document";
      }
    }
  }
};
</script>
